var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['dashboard', _vm.routeClass ]},[_c('Navbar',{attrs:{"tabColor":_vm.tabColor}}),_c('Sidebar',{attrs:{"sidebar":_vm.routeClass,"tabColor":_vm.tabColor},on:{"sidebarWidth":_vm.setSidebarWidth}}),_c('div',{staticClass:"content"},[_c('router-view',{on:{"tabColor":_vm.setTabColor}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }